// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   PREMIUM NOTIFICATION COMPONENT STYLES
   ========================================================================== */

.premiumNotificationPage {
  padding: 30px 40px;
  background-color: #ffffff;
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header & Delete Button */
.premiumNotificationHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 35px;
}

.premiumNotificationHeaderLeft {
  display: flex;
  flex-direction: column;
}

.premiumNotificationTitle {
  font-size: 36px;
  font-weight: 700;
  color: #000000;
  margin: 0 0 6px 0;
  letter-spacing: -0.5px;
}

.premiumNotificationSubtitle {
  font-size: 14.5px;
  color: #718096;
  margin: 0 0 14px 0;
  font-weight: 500;
}

.premiumNotificationTitleDivider {
  width: 250px;
  height: 1.5px;
  background-color: #cbd5e0;
}

.premiumNotificationDeleteAllBtn {
  background-color: #2f3299;
  color: #ffffff;
  font-size: 14.5px;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 12px rgba(47, 50, 153, 0.25);
}

.premiumNotificationDeleteAllBtn:hover:not(:disabled) {
  background-color: #242678;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(47, 50, 153, 0.35);
}

.premiumNotificationDeleteAllBtn:active:not(:disabled) {
  transform: translateY(0);
}

.premiumNotificationDeleteAllBtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

/* Notification List stack */
.premiumNotificationList {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 100%;
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 10px; /* Space for scrollbar */
  padding-bottom: 30px; /* Space at bottom of list */
}

/* Custom scrollbar for list */
.premiumNotificationList::-webkit-scrollbar {
  width: 6px;
}
.premiumNotificationList::-webkit-scrollbar-track {
  background: transparent;
}
.premiumNotificationList::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.premiumNotificationList::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

/* Premium Card Layout */
.premiumNotificationCard {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 14px 24px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  cursor: pointer;
}

.premiumNotificationCard:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
}

/* Unread State: Light Violet/Blue Background */
.premiumNotificationCard.unread {
  background-color: #e2e8f7; /* Matching light violet tint */
  border-color: rgba(47, 50, 153, 0.1);
}

.premiumNotificationCard.unread:hover {
  background-color: #dbe2f5;
}

/* Read State: Soft Gray Background */
.premiumNotificationCard.read {
  background-color: #ebebeb; /* Matching light gray tint */
  border-color: rgba(0, 0, 0, 0.04);
}

.premiumNotificationCard.read:hover {
  background-color: #e2e2e2;
}

/* Left Circle & Bell Icon */
.premiumNotificationIconCircle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #2f3299;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(47, 50, 153, 0.3);
}

.premiumNotificationBell {
  width: 20px;
  height: 20px;
}

.premiumNotificationUnreadBadge {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  background-color: #e53e3e;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(229, 62, 62, 0.3);
}

/* Content (Middle) */
.premiumNotificationContent {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-right: 20px;
}

.premiumNotificationCardTitle {
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  line-height: 1.4;
}

.premiumNotificationCardTime {
  font-size: 11.5px;
  color: #718096;
  font-weight: 600;
}

/* Options / Ellipsis (Right) */
.premiumNotificationOptionsWrapper {
  position: relative;
}

.premiumNotificationOptionsBtn {
  background: none;
  border: none;
  cursor: pointer;
  color: #718096;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.premiumNotificationOptionsBtn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #1a202c;
}

.premiumNotificationEllipsis {
  width: 18px;
  height: 18px;
}

/* Dropdown Menu styling */
.premiumNotificationDropdown {
  position: absolute;
  right: 0;
  top: 40px;
  z-index: 100;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  padding: 4px;
  width: 135px;
  animation: dropdownPop 0.18s cubic-bezier(0.4, 0, 0.2, 1);
}

.premiumNotificationDropdownItem {
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  border: none;
  background: none;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  color: #4a5568;
}

.premiumNotificationDropdownItem:hover {
  background-color: #f7fafc;
  color: #1a202c;
}

.dropdownDeleteIcon {
  width: 14px;
  height: 14px;
}

/* No data styling */
.premiumNotificationNoData {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
  color: #a0aec0;
  background: rgba(0, 0, 0, 0.01);
  border: 1.5px dashed rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}

.premiumNotificationNoData svg {
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  color: #cbd5e0;
}

.premiumNotificationNoData h6 {
  font-size: 15px;
  font-weight: 600;
  color: #718096;
  margin: 0;
}

/* Animations */
@keyframes dropdownPop {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-5px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Response Adaptability */
@media (max-width: 768px) {
  .premiumNotificationPage {
    padding: 20px 16px;
  }
  
  .premiumNotificationHeader {
    flex-direction: column;
    gap: 16px;
  }
  
  .premiumNotificationDeleteAllBtn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/notification/notification.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB,EAAE,wBAAwB;EAC7C,oBAAoB,EAAE,4BAA4B;AACpD;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB,EAAE,+BAA+B;EAC1D,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,yBAAyB,EAAE,6BAA6B;EACxD,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ==========================================================================\n   PREMIUM NOTIFICATION COMPONENT STYLES\n   ========================================================================== */\n\n.premiumNotificationPage {\n  padding: 30px 40px;\n  background-color: #ffffff;\n  height: calc(100vh - 70px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Header & Delete Button */\n.premiumNotificationHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 35px;\n}\n\n.premiumNotificationHeaderLeft {\n  display: flex;\n  flex-direction: column;\n}\n\n.premiumNotificationTitle {\n  font-size: 36px;\n  font-weight: 700;\n  color: #000000;\n  margin: 0 0 6px 0;\n  letter-spacing: -0.5px;\n}\n\n.premiumNotificationSubtitle {\n  font-size: 14.5px;\n  color: #718096;\n  margin: 0 0 14px 0;\n  font-weight: 500;\n}\n\n.premiumNotificationTitleDivider {\n  width: 250px;\n  height: 1.5px;\n  background-color: #cbd5e0;\n}\n\n.premiumNotificationDeleteAllBtn {\n  background-color: #2f3299;\n  color: #ffffff;\n  font-size: 14.5px;\n  font-weight: 600;\n  padding: 10px 24px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0 4px 12px rgba(47, 50, 153, 0.25);\n}\n\n.premiumNotificationDeleteAllBtn:hover:not(:disabled) {\n  background-color: #242678;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(47, 50, 153, 0.35);\n}\n\n.premiumNotificationDeleteAllBtn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.premiumNotificationDeleteAllBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* Notification List stack */\n.premiumNotificationList {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  max-width: 100%;\n  flex-grow: 1;\n  overflow-y: auto;\n  padding-right: 10px; /* Space for scrollbar */\n  padding-bottom: 30px; /* Space at bottom of list */\n}\n\n/* Custom scrollbar for list */\n.premiumNotificationList::-webkit-scrollbar {\n  width: 6px;\n}\n.premiumNotificationList::-webkit-scrollbar-track {\n  background: transparent;\n}\n.premiumNotificationList::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n}\n.premiumNotificationList::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n/* Premium Card Layout */\n.premiumNotificationCard {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 14px 24px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);\n  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  cursor: pointer;\n}\n\n.premiumNotificationCard:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);\n}\n\n/* Unread State: Light Violet/Blue Background */\n.premiumNotificationCard.unread {\n  background-color: #e2e8f7; /* Matching light violet tint */\n  border-color: rgba(47, 50, 153, 0.1);\n}\n\n.premiumNotificationCard.unread:hover {\n  background-color: #dbe2f5;\n}\n\n/* Read State: Soft Gray Background */\n.premiumNotificationCard.read {\n  background-color: #ebebeb; /* Matching light gray tint */\n  border-color: rgba(0, 0, 0, 0.04);\n}\n\n.premiumNotificationCard.read:hover {\n  background-color: #e2e2e2;\n}\n\n/* Left Circle & Bell Icon */\n.premiumNotificationIconCircle {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background-color: #2f3299;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 4px 10px rgba(47, 50, 153, 0.3);\n}\n\n.premiumNotificationBell {\n  width: 20px;\n  height: 20px;\n}\n\n.premiumNotificationUnreadBadge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 12px;\n  height: 12px;\n  background-color: #e53e3e;\n  border-radius: 50%;\n  border: 2px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(229, 62, 62, 0.3);\n}\n\n/* Content (Middle) */\n.premiumNotificationContent {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding-right: 20px;\n}\n\n.premiumNotificationCardTitle {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.premiumNotificationCardTime {\n  font-size: 11.5px;\n  color: #718096;\n  font-weight: 600;\n}\n\n/* Options / Ellipsis (Right) */\n.premiumNotificationOptionsWrapper {\n  position: relative;\n}\n\n.premiumNotificationOptionsBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #718096;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.premiumNotificationOptionsBtn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #1a202c;\n}\n\n.premiumNotificationEllipsis {\n  width: 18px;\n  height: 18px;\n}\n\n/* Dropdown Menu styling */\n.premiumNotificationDropdown {\n  position: absolute;\n  right: 0;\n  top: 40px;\n  z-index: 100;\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);\n  padding: 4px;\n  width: 135px;\n  animation: dropdownPop 0.18s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.premiumNotificationDropdownItem {\n  width: 100%;\n  text-align: left;\n  padding: 8px 12px;\n  border: none;\n  background: none;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  color: #4a5568;\n}\n\n.premiumNotificationDropdownItem:hover {\n  background-color: #f7fafc;\n  color: #1a202c;\n}\n\n.dropdownDeleteIcon {\n  width: 14px;\n  height: 14px;\n}\n\n/* No data styling */\n.premiumNotificationNoData {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 20px;\n  text-align: center;\n  color: #a0aec0;\n  background: rgba(0, 0, 0, 0.01);\n  border: 1.5px dashed rgba(0, 0, 0, 0.05);\n  border-radius: 16px;\n}\n\n.premiumNotificationNoData svg {\n  width: 48px;\n  height: 48px;\n  margin-bottom: 16px;\n  color: #cbd5e0;\n}\n\n.premiumNotificationNoData h6 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #718096;\n  margin: 0;\n}\n\n/* Animations */\n@keyframes dropdownPop {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Response Adaptability */\n@media (max-width: 768px) {\n  .premiumNotificationPage {\n    padding: 20px 16px;\n  }\n  \n  .premiumNotificationHeader {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .premiumNotificationDeleteAllBtn {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
